import {
  DOMAIN_ZELFHULP_ALCOHOL,
  ZELFHULP_ALCOHOL_MAXIMUM_WEEK_USAGE,
  ZELFHULP_ALCOHOL_MAXIMUM_DAY_USAGE,
} from '../config/constants';
import getCurrentDomain from './getCurrentDomain';

type CurrentUsageValues = Record<string, string>;

function isAlcoholUsageLimitReached(currentUsageValues: CurrentUsageValues): boolean {
  const domain = getCurrentDomain();

  if (domain !== DOMAIN_ZELFHULP_ALCOHOL) {
    return false;
  }

  let cumulativeValues = 0;
  let isDayLimitReached = false;
  const usageValues = Object.values(currentUsageValues);

  usageValues.forEach((usageValue) => {
    const parsed = parseFloat(usageValue);
    if (Number.isNaN(parsed)) return;
    cumulativeValues += parsed;

    if (parsed >= ZELFHULP_ALCOHOL_MAXIMUM_DAY_USAGE) {
      isDayLimitReached = true;
    }
  });

  if (cumulativeValues >= ZELFHULP_ALCOHOL_MAXIMUM_WEEK_USAGE || isDayLimitReached) {
    return true;
  }

  return false;
}

export default isAlcoholUsageLimitReached;
